import { render, staticRenderFns } from "./BroadAnswerQuestion.vue?vue&type=template&id=0a58c539&scoped=true"
import script from "./BroadAnswerQuestion.vue?vue&type=script&lang=js"
export * from "./BroadAnswerQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a58c539",
  null
  
)

export default component.exports